import { createMiddleware } from "redux-beacon";
import GoogleTagManager from "@redux-beacon/google-tag-manager";
import { eventsMapper } from "../../analytics";

export default createMiddleware(eventsMapper, GoogleTagManager());
